const { READ_ONLY_FEATURES } = process.env;

const crudConfig = {
    endpoint: 'conceptdeterminationmethods',
    primaryKey: 'codeId',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['codeId']
        }
    },
    metadata: {
        endpoint: 'cds/conceptdeterminationmethods',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'cds',
                args: [],
                query: {}
            }
        }
    }
};

if (!READ_ONLY_FEATURES || READ_ONLY_FEATURES === 'false') {
    crudConfig.functions = {
        ...crudConfig.functions,
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds'
            // args: ['nodeId', 'nodeDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds'
            // args: ['nodeId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds'
            // args: ['nodeDoc']
        }
    };
}

export default crudConfig;
